import { useEffect } from "react";
import type { NextRouter } from "next/router";
import { LoggerService } from "@Front/Services/LoggerService/LoggerService";
import type { LoginStep } from "@Front/Components/Layouts/Login/hooks/useLoginController";

export function useLoginPageLoadLog(router: NextRouter, step: LoginStep): void {
	useEffect(() => {
		LoggerService.info("✅ [Login] Page chargée - le client doit saisir son email manuellement");
	}, [router.query, step, router]);
}
